export default {
    // ******************************************
    // Globals
    // ******************************************
    global_brand_name: "Rosetta Stone",
    product_name: "Rosetta Stone",

    // ******************************************
    // Globals - Locales
    // ******************************************
    locale_ar_ar_label_primary: "Arabisch",
    locale_ar_ar_label_secondary: "",
    locale_de_de_label_primary: "Deutsch",
    locale_de_de_label_secondary: "",
    locale_el_gr_label_primary: "Griechisch",
    locale_el_gr_label_secondary: "",
    locale_en_gb_label_primary: "Englisch",
    locale_en_gb_label_secondary: "Britisch",
    locale_en_us_label_primary: "Englisch",
    locale_en_us_label_secondary: "Amerikanisch",
    locale_es_es_label_primary: "Spanisch",
    locale_es_es_label_secondary: "",
    locale_es_la_label_primary: "Spanisch",
    locale_es_la_label_secondary: "Lateinamerika",
    locale_fa_ir_label_primary: "Persisch",
    locale_fa_ir_label_secondary: "Farsi",
    locale_fr_fr_label_primary: "Französisch",
    locale_fr_fr_label_secondary: "",
    locale_ga_ie_label_primary: "Irisch",
    locale_ga_ie_label_secondary: "",
    locale_he_il_label_primary: "Hebräisch",
    locale_he_il_label_secondary: "",
    locale_hi_in_label_primary: "Hindi",
    locale_hi_in_label_secondary: "",
    locale_it_it_label_primary: "Italienisch",
    locale_it_it_label_secondary: "",
    locale_ja_jp_label_primary: "Japanisch",
    locale_ja_jp_label_secondary: "",
    locale_ko_kr_label_primary: "Koreanisch",
    locale_ko_kr_label_secondary: "",
    locale_la_va_label_primary: "Latin",
    locale_la_va_label_secondary: "",
    locale_nl_nl_label_primary: "Niederländisch",
    locale_nl_nl_label_secondary: "",
    locale_pl_pl_label_primary: "Polnisch",
    locale_pl_pl_label_secondary: "",
    locale_pt_br_label_primary: "Portugiesisch",
    locale_pt_br_label_secondary: "Brazil",
    locale_ru_ru_label_primary: "Russisch",
    locale_ru_ru_label_secondary: "",
    locale_sv_se_label_primary: "Schwedisch",
    locale_sv_se_label_secondary: "",
    locale_tl_ph_label_primary: "Philippinisch",
    locale_tl_ph_label_secondary: "Tagalog",
    locale_tr_tr_label_primary: "Türkisch",
    locale_tr_tr_label_secondary: "",
    locale_vi_vn_label_primary: "Vietnamesisch",
    locale_vi_vn_label_secondary: "",
    locale_zn_cn_label_primary: "Chinesisch",
    locale_zn_cn_label_secondary: "Mandarin",

    // ******************************************
    // Nav Primary
    // ******************************************
    nav_primary_blog_label: "Magazine",
    nav_primary_catalog_label: "Sprachen Und Preise",
    nav_primary_catalog_select_language_label: "Wähle eine Sprache",
    nav_primary_contact_label: "Kontakt",
    nav_primary_logo_alt: "Rosetta Stone",
    nav_primary_phone_label: "Fragen? Ruf Sie uns an:",
    nav_primary_phone_number: "0800 724 0778",
    nav_primary_sign_in_label: "Login",
    nav_primary_support_label: "Support",
    nav_primary_switch_language: "",
    nav_primary_vertical_consumer_label: "",
    nav_primary_vertical_education_for_homeschool_label: "",
    nav_primary_vertical_education_for_students_label: "",
    nav_primary_vertical_education_homeschool_label: "",
    nav_primary_vertical_education_primary_label: "Bildungseinrichtungen",
    nav_primary_vertical_education_secondary_label: "",
    nav_primary_vertical_education_students_label: "",
    nav_primary_vertical_enterprise_label: "Unternehmen",

    // ******************************************
    // Nav Secondary - Enterprise
    // ******************************************
    nav_secondary_enterprise_blog_label: "",
    nav_secondary_enterprise_custom_1_label: "",
    nav_secondary_enterprise_home_label: "Home",
    nav_secondary_enterprise_label: "Unternehmen",
    nav_secondary_enterprise_resources_label: "Ressourcen",
    nav_secondary_enterprise_solutions_label: "Lösungen",

    // ******************************************
    // Nav Secondary - Education Primary
    // ******************************************
    nav_secondary_education_primary_blog_label: "",
    nav_secondary_education_primary_home_label: "Home",
    nav_secondary_education_primary_label: "Schulen",
    nav_secondary_education_primary_resources_label: "Ressourcen",
    nav_secondary_education_primary_solutions_label: "Lösungen",

    // ******************************************
    // Nav Secondary - Education Secondary
    // ******************************************
    nav_secondary_education_secondary_blog_label: "",
    nav_secondary_education_secondary_custom_1_label: "",
    nav_secondary_education_secondary_home_label: "",
    nav_secondary_education_secondary_label: "",
    nav_secondary_education_secondary_resources_label: "",
    nav_secondary_education_secondary_solutions_label: "",

    // ******************************************
    // Nav Secondary - Education Homeschool
    // ******************************************
    nav_secondary_education_homeschool_blog_label: "",
    nav_secondary_education_homeschool_home_label: "",
    nav_secondary_education_homeschool_label: "",
    nav_secondary_education_homeschool_resources_label: "",
    nav_secondary_education_homeschool_solutions_label: "Solutions",

    // ******************************************
    // Nav Secondary - Services
    // ******************************************
    nav_secondary_services_blog_label: "",
    nav_secondary_services_home_label: "",
    nav_secondary_services_label: "",
    nav_secondary_services_resources_label: "",
    nav_secondary_services_solutions_label: "",

    // ******************************************
    // Shared - Awards
    // ******************************************
    awards_header_label: "Seit 25+ Jahren von Top-Organisationen genutzt",
    awards_bmw: "BMW",
    awards_ikea: "Ikea",
    awards_lego: "Lego",
    awards_twitter: "Twitter",
    awards_uber: "Uber",
    awards_williams_sonoma: "Williams Sonoma",

    // ******************************************
    // Shared - Branded Quotes
    // ******************************************
    branded_quotes_header_label: "Was die Leute über uns sagen",
    branded_quotes_cnn_name: "CNN",
    branded_quotes_cnn_quote: "&quot;Der <em>Gold-Status</em> an computerbasiertem Sprachenlernen.&quot;",
    branded_quotes_cnn_type: "cnn",

    branded_quotes_macworld_name: "MacWorld",
    branded_quotes_macworld_quote:
        "&quot;Ich bin von der Rosetta Stone Sprachlernlösung begeistert und fest davon überzeugt, <em>dass der Lernansatz funktioniert.</em>&quot;",
    branded_quotes_macworld_type: "macworld",

    branded_quotes_techcrunch_name: "TechCrunch",
    branded_quotes_techcrunch_quote:
        "&quot;Mit den benutzerfreundlichen Interfaces, klaren Anweisungen sowie der großen Auswahl an Spielen und sonstigen Lern-Tools hat es <em>Rosetta Stone einfach drauf.</em>&quot;",
    branded_quotes_techcrunch_type: "techcrunch",

    // ******************************************
    // Shared - Related Resources
    // ******************************************
    related_resources_label: "",
    related_resources_button_label: "",

    // ******************************************
    // Shared - Verticals
    // ******************************************
    verticals_label: "Welche Art von Lerner bist du?",
    verticals_education_primary: "Schulen",
    verticals_education_secondary: "Hochschulen",
    verticals_enterprise: "Unternehmen",
    verticals_publicsector: "Öffentlicher Sektor",

    // ******************************************
    // Footer
    // ******************************************
    // CTA Form
    footer_cta_email_button: "",
    footer_cta_email_main_label: "",
    footer_cta_email_placeholder: "",
    footer_cta_form_comments: "Wie können wir Ihnen weiter helfen?",
    footer_cta_form_country: "Country",
    footer_cta_form_email: "E-Mail",
    footer_cta_form_firstname: "Vorname",
    footer_cta_form_lastname: "Nachname",
    footer_cta_form_organization: "Unternehmen",
    footer_cta_form_organizationsize: "form_organizationsize",
    footer_cta_form_organizationsize_100: "form_100",
    footer_cta_form_organizationsize_500: "form_500",
    footer_cta_form_organizationsize_1000: "form_1000",
    footer_cta_form_organizationsize_5000: "form_5000",
    footer_cta_form_organizationsize_10000: "form_10000",
    footer_cta_form_organizationsize_25000: "form_25000",
    footer_cta_form_organizationsize_50000: "form_50000",
    footer_cta_form_organizationsize_more: "form_more",
    footer_cta_form_phone: "Telefonnummer (optional)",
    footer_cta_form_pricing_thanks:
        "Danke für Ihr Interesse! In Kürze wird sich jemand mit Ihnen in Verbindung setzen.",
    footer_cta_form_role: "Rolle (oder Titel)",
    footer_cta_form_role_boardmember: "Vorstandsmitglied",
    footer_cta_form_role_curriculumdirector: "Lehrplanleiter / Instruktionskoordinator",
    footer_cta_form_role_director: "Direktor",
    footer_cta_form_role_executive: "Geschäftsführung / Executive",
    footer_cta_form_role_individualcontributor: "Einzelner Mitwirkender",
    footer_cta_form_role_manager: "Manager",
    footer_cta_form_role_principal: "Auftraggeber / Vizepräsident",
    footer_cta_form_role_superintendent: "Superintendent/District Administrator",
    footer_cta_form_role_teacher: "Lehrer",
    footer_cta_form_role_techcoordinator: "Technologiekoordinator",
    footer_cta_form_role_vicepresident: "Vizepräsident",
    footer_cta_form_submit: "JETZT ANGEBOT ANFORDERN",
    footer_cta_opt_in_learn_more_button_text: "Mehr erfahren",
    footer_cta_opt_in_learn_more_link_text_1: "Datenschutzrichtlinie von Rosetta Stone ",
    footer_cta_opt_in_learn_more_privacyemail: " privacyofficer@rosettastone.com",
    footer_cta_opt_in_learn_more_privacyUrl:
        "https://resources.rosettastone.com/CDN/de/pdfs/website-privacy-policy-de.pdf",
    footer_cta_opt_in_learn_more_text_1:
        "Ich stimme dem Erhalt von Info- und Marketingmaterial über Produktneuigkeiten, Angebote oder Einladungen zu Veranstaltungen von Rosetta Stone zu. Es ist mir bewusst, dass meine Daten mit internationalen Partnern, die Dienstleistungen für Rosetta Stone anbieten im Rahmen der",
    footer_cta_opt_in_learn_more_text_2: " privacyofficer@rosettastone.com",
    footer_cta_opt_in_learn_more_text_3: " kontaktiere.",
    footer_cta_opt_in_text_after_button: "",
    footer_cta_opt_in_text_before_button: "Ja, ich möchte Produktneuigkeiten und Angebote von Rosetta Stone erhalten. ",
    footer_cta_pricing_button: "ANGEBOT ANFORDERN",
    footer_cta_pricing_label: "Bereit für den nächsten Schritt?",
    footer_cta_pricing_subtitle: "Haben wir Ihr Interesse geweckt? Fordern Sie Ihr individuelles Angebot an.",
    footer_cta_pricing_title: "Bitte ausfüllen und wir melden uns umgehend bei Ihnen.",

    // Menu
    footer_menu_about_about_us_label: "Über Uns",
    footer_menu_about_blog_label: "Blog",
    footer_menu_about_careers_label: "Karriere",
    footer_menu_about_contact_label: "Kontakt",
    footer_menu_about_label: "Unternehmen",
    footer_menu_about_press_label: "Presse",
    footer_menu_products_consumer_label: "Für Einzelpersonen",
    footer_menu_products_education_primary_label: "Bildungseinrichtungen",
    footer_menu_products_education_secondary_label: "Für Hochschullehrer",
    footer_menu_products_enterprise_label: "Unternehmen",
    footer_menu_products_label: "Überblick",
    footer_menu_products_publicsector_label: "Öffentlicher Sektor",
    footer_menu_support_faqs_label: "FAQs",
    footer_menu_support_label: "Support",
    footer_menu_support_support_site_label: "Support Site",
    footer_menu_support_system_requirements_label: "Systemanforderungen",
    footer_meta_agreements_label: "Vereinbarungen",
    footer_meta_ccpa_label: "Do Not Sell My Information",
    footer_meta_cookie_settings_label: "Cookie-Einstellungen",
    footer_meta_copyright_alt: "Go to home page",
    footer_meta_copyright_IXL: "A division of IXL Learning",
    footer_meta_copyright_label: " Rosetta Stone GmbH. Alle Rechte vorbehalten.",
    footer_meta_privacy_policy_label: "Datenschutzrichtlinie",
    footer_meta_terms_conditions_label: "Nutzungsbedingungen",

    // Region
    footer_region_label: "Region ändern",
    footer_region_options_au_label: "Australia",
    footer_region_options_br_label: "Brasil",
    footer_region_options_cn_label: "中国",
    footer_region_options_de_label: "Deutschland",
    footer_region_options_es_label: "España",
    footer_region_options_eu_label: "Europe",
    footer_region_options_fr_label: "France",
    footer_region_options_it_label: "Italia",
    footer_region_options_jp_label: "日本",
    footer_region_options_kr_label: "대한민국",
    footer_region_options_la_label: "America Latina",
    footer_region_options_uk_label: "United Kingdom",
    footer_region_options_us_label: "United States",

    // Social
    footer_social_label: "Kontaktieren Sie uns",
    footer_social_facebook_alt: "Facebook",
    footer_social_instagram_alt: "Instagram",
    footer_social_twitter_alt: "Twitter",
    footer_social_youtube_alt: "Youtube"
};
